'use client';

import { useTranslations } from 'next-intl';
import React from 'react';

import { useDomainConfiguration } from '@/components/DomainConfigurationProvider';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';

import GretaLogo from './GretaLogo';

const GRETA_APP_STORE_URL = 'https://apps.apple.com/de/app/greta/id793892423';
const GRETA_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=de.debesefilm.greta';

const appStoreBadge = loadAsset('/images/badges/im-appStoreDE.png');
const playStoreBadge = loadAsset('/images/badges/im-playStoreDE.png');

const GretaAdSection: React.FC = () => {
    const t = useTranslations('greta');
    const { movie } = useDomainConfiguration();
    const { track } = useAnalytics();

    return (
        <section>
            <div className="flex flex-col-reverse lg:flex-row items-center rounded-16 bg-[#3A3000] border-1 border-[#FFD700] p-24 lg:p-32 gap-24">
                <div className="flex-1 flex flex-col gap-16">
                    <h2 className="text-headline-20 lg:text-headline-24">{t('title')}</h2>
                    <p className="text-body-14">
                        {t.rich('description', {
                            movieTitle: movie.title,
                            bold: (chunks) => <strong>{chunks}</strong>
                        })}
                    </p>
                    <div className="flex flex-row gap-16">
                        <a
                            href={GRETA_APP_STORE_URL}
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => track('GRETA App Store Clicked')}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img
                                className="h-48"
                                src={appStoreBadge}
                                alt="App Store"
                            />
                        </a>
                        <a
                            href={GRETA_PLAY_STORE_URL}
                            target="_blank"
                            rel="noreferrer"
                            onClick={() => track('GRETA Play Store Clicked')}>
                            {/* eslint-disable-next-line @next/next/no-img-element */}
                            <img
                                className="h-48"
                                src={playStoreBadge}
                                alt="Google Play"
                            />
                        </a>
                    </div>
                </div>
                <GretaLogo className="w-[96px] h-[91px] flex-none" />
            </div>
        </section>
    );
};

export default GretaAdSection;
